export default {
    set_authDonor: (state, payload)=>{
        state.authDonor = payload;
    },
    set_csrfToken: (state, payload)=>{
        state.csrfToken = payload;
    },
    set_createNewAccountData: (state, payload)=>{
        if(typeof payload.email !== 'undefined') state.createNewAccountData.email = payload.email
        if(typeof payload.password !== 'undefined') state.createNewAccountData.password = payload.password
        if(typeof payload.firstName !== 'undefined') state.createNewAccountData.firstName = payload.firstName
        if(typeof payload.lastName !== 'undefined') state.createNewAccountData.lastName = payload.lastName
        if(typeof payload.dob !== 'undefined') state.createNewAccountData.dob = payload.dob
        if(typeof payload.idDonationOrDonor !== 'undefined') state.createNewAccountData.idDonationOrDonor = payload.idDonationOrDonor
        if(typeof payload.phoneMobile !== 'undefined') state.createNewAccountData.phoneMobile = payload.phoneMobile
        if(typeof payload.smsOptedOut !== 'undefined') state.createNewAccountData.smsOptedOut = payload.smsOptedOut
        if(typeof payload.idDonor !== 'undefined') state.createNewAccountData.idDonor = payload.idDonor
    },
    set_showPage: (state, payload)=>{
        if(typeof payload.triggerRequestActivationCode !== 'undefined') state.showPage.triggerRequestActivationCode = payload.triggerRequestActivationCode
        if(typeof payload.triggerEnterActivationCode !== 'undefined') state.showPage.triggerEnterActivationCode = payload.triggerEnterActivationCode

    },
}
